import { z } from 'zod';
import { FILE_ATTENTE_STATUTS } from '../constants/statuses.js';
import { paginationQuerySchema } from './common.js';
/**
 * File d'attente réception → biométrie.
 *
 * Le poste d'accueil (agent documentaire) reçoit la personne, vérifie et
 * valide sa pièce d'identité, puis l'oriente vers la biométrie : elle entre
 * alors dans cette file. Le poste biométrique ne travaille QUE sur cette file
 * — la règle est appliquée côté API (`apps/api/src/modules/biometrie/`), pas
 * seulement à l'écran, sans quoi ce ne serait pas un contrôle.
 *
 * Ces schémas ne valident que la forme des requêtes ; la condition métier
 * (« au moins une pièce d'identité validée », voir
 * `DOCUMENT_TYPES_IDENTITE`) est vérifiée côté serveur, seul endroit où l'état
 * réel des documents est connu.
 */
export const orienterVersBiometrieSchema = z.object({
    travailleurUuid: z.string().uuid(),
    commentaire: z.string().max(1000).optional(),
});
export const annulerFileAttenteSchema = z.object({
    motif: z.string().trim().min(3).max(500),
});
export const listFileAttenteQuerySchema = paginationQuerySchema.extend({
    /** Par défaut la file vivante (`en_attente`) — c'est la salle d'attente du moment. */
    statut: z.enum(FILE_ATTENTE_STATUTS).optional(),
    search: z.string().max(160).optional(),
});
//# sourceMappingURL=file-attente.js.map